if (window.wp && window.wp.ajax)
{
    const { registerBlockType } = window.wp.blocks;

const {
    RichText,
    InspectorControls,
    ColorPalette,
    MediaUpload,
    InnerBlocks
} = window.wp.editor;

const {
    PanelBody,
    IconButton,
    RangeControl,
    TextControl
} = window.wp.components;


if (window.wp.ajax)
{
    registerBlockType('custom-gutenberg/offer-card', {
        // built-in attributes
        title: 'Offer card',
        description: 'Custom Offer card',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            backgroundImage: {
                type: 'string',
                default: '/wp-content/uploads/m14-011-00015-16866.jpg'
            },
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: ''
            },
        },

        // built-in functions
        edit({ attributes, setAttributes })
        {

            const {
                link,
                backgroundImage,
                title,
                description,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange(link)
            {
                setAttributes({ link: link });
            };

            function onSelectImage(image)
            {
                setAttributes({ backgroundImage: image.sizes.full.url });
            }

            function onTitleChange(title)
            {
                setAttributes({ title: title });
            }

            function onDescriptionChange(description)
            {
                setAttributes({ description: description });
            }

            function onViewMoreChange(viewMore)
            {
                setAttributes({ viewMore: viewMore });
            }

            return ([
                <InspectorControls style={{ marginBottom: '40px' }}>

                </InspectorControls>
                ,
                <div className="row">
                    <div class="col-lg-4 mb-lg-5 mb-0 mt-4 mt-lg-0">
                        <div class="card shadow p-0 rounded-top h-100 villa-card villas-lozad">
                            <div class="position-relative">
                                <div class="color-overlay-card rounded-top">
                                </div>
                                <div class="bg-dark rounded-top">
                                    <div class="show-on-desktop">
                                        <div id="villa-card-slider-1017896553" style={{ height: '200px' }}
                                            class="keen-slider keen-slider__fade overflow-hidden rounded-top keen-slider__created">

                                        </div>

                                    </div>

                                </div>
                                <div class="position-absolute top-0 start-0 end-0 pt-2 px-3" >
                                    <div class="row g-0 justify-content-between w-100">
                                        <div class="col-lg text-white headings-font-family">
                                            <i class="las la-map-marker me-2">
                                            </i>
                                            <span >{'Croatia, Istria, Rovinjsko Selo'}
                                            </span>

                                        </div>
                                        <div class="col-auto text-white fw-bold">
                                            <i class="las la-star me-2 text-warning">
                                            </i>{'10'}

                                        </div>

                                    </div>

                                </div>
                                <div class="position-absolute bottom-0 end-0 w-100" >
                                    <div class="d-flex justify-content-end align-items-end">
                                        <div class="px-3 py-2 bg-dark bg-opacity-75 d-flex" >
                                            <div class="d-flex ">
                                                <div class="small headings-font-family text-white me-3 text-start">
                                                    {'Price per week  starting from'}

                                                </div>

                                            </div>
                                            <div class="d-flex justify-content-end align-items-end">
                                                <div class="h2 text-warning fw-bolder mb-0">
                                                    <span class="details-currency">{'€'}
                                                    </span>
                                                    <span class="price" data-priceeuro="2945">
                                                        {'2.945'}

                                                    </span>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                            <div class="card-body d-flex flex-column justify-content-between px-4 py-3">
                                <div class="row">
                                    <div class="col">
                                        <div class="h3 mb-2 fw-bolder object-title">Villa #1
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-betwee">
                                    <div class="col-auto">
                                        <div class="row g-0">
                                            <div class="col-auto"> <i class="las la-bed me-2 text-warning la-lg">
                                            </i>
                                            </div>
                                            <div class="col d-flex align-items-center"> <span class="text-muted small">4 bedrooms
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="row g-0">
                                            <div class="col-auto"> <i class="las la-user me-2 text-warning la-lg">
                                            </i>
                                            </div>
                                            <div class="col d-flex align-items-center"> <span class="text-muted small"> 8 guests
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="row g-0">
                                            <div class="col-auto"> <i class="las la-paw me-2 text-warning la-lg">
                                            </i>
                                            </div>
                                            <div class="col d-flex align-items-center"> <span class="text-muted small "> Pets allowed
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-lg-4 mb-lg-5 mb-0 mt-4 mt-lg-0">
                        <div class="card shadow p-0 rounded-top h-100 villa-card villas-lozad">
                            <div class="position-relative">
                                <div class="color-overlay-card rounded-top">
                                </div>
                                <div class="bg-dark rounded-top">
                                    <div class="show-on-desktop">
                                        <div id="villa-card-slider-1017896553" style={{ height: '200px' }}
                                            class="keen-slider keen-slider__fade overflow-hidden rounded-top keen-slider__created">

                                        </div>

                                    </div>

                                </div>
                                <div class="position-absolute top-0 start-0 end-0 pt-2 px-3" >
                                    <div class="row g-0 justify-content-between w-100">
                                        <div class="col-lg text-white headings-font-family">
                                            <i class="las la-map-marker me-2">
                                            </i>
                                            <span >{'Croatia, Istria, Rovinjsko Selo'}
                                            </span>

                                        </div>
                                        <div class="col-auto text-white fw-bold">
                                            <i class="las la-star me-2 text-warning">
                                            </i>{'10'}

                                        </div>

                                    </div>

                                </div>
                                <div class="position-absolute bottom-0 end-0 w-100" >
                                    <div class="d-flex justify-content-end align-items-end">
                                        <div class="px-3 py-2 bg-dark bg-opacity-75 d-flex" >
                                            <div class="d-flex ">
                                                <div class="small headings-font-family text-white me-3 text-start">
                                                    {'Price per week  starting from'}

                                                </div>

                                            </div>
                                            <div class="d-flex justify-content-end align-items-end">
                                                <div class="h2 text-warning fw-bolder mb-0">
                                                    <span class="details-currency">{'€'}
                                                    </span>
                                                    <span class="price" data-priceeuro="2945">
                                                        {'2.945'}

                                                    </span>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                            <div class="card-body d-flex flex-column justify-content-between px-4 py-3">
                                <div class="row">
                                    <div class="col">
                                        <div class="h3 mb-2 fw-bolder object-title">Villa #1
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-betwee">
                                    <div class="col-auto">
                                        <div class="row g-0">
                                            <div class="col-auto"> <i class="las la-bed me-2 text-warning la-lg">
                                            </i>
                                            </div>
                                            <div class="col d-flex align-items-center"> <span class="text-muted small">4 bedrooms
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="row g-0">
                                            <div class="col-auto"> <i class="las la-user me-2 text-warning la-lg">
                                            </i>
                                            </div>
                                            <div class="col d-flex align-items-center"> <span class="text-muted small"> 8 guests
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="row g-0">
                                            <div class="col-auto"> <i class="las la-paw me-2 text-warning la-lg">
                                            </i>
                                            </div>
                                            <div class="col d-flex align-items-center"> <span class="text-muted small "> Pets allowed
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-lg-4 mb-lg-5 mb-0 mt-4 mt-lg-0">
                        <div class="card shadow p-0 rounded-top h-100 villa-card villas-lozad">
                            <div class="position-relative">
                                <div class="color-overlay-card rounded-top">
                                </div>
                                <div class="bg-dark rounded-top">
                                    <div class="show-on-desktop">
                                        <div id="villa-card-slider-1017896553" style={{ height: '200px' }}
                                            class="keen-slider keen-slider__fade overflow-hidden rounded-top keen-slider__created">

                                        </div>

                                    </div>

                                </div>
                                <div class="position-absolute top-0 start-0 end-0 pt-2 px-3" >
                                    <div class="row g-0 justify-content-between w-100">
                                        <div class="col-lg text-white headings-font-family">
                                            <i class="las la-map-marker me-2">
                                            </i>
                                            <span >{'Croatia, Istria, Rovinjsko Selo'}
                                            </span>

                                        </div>
                                        <div class="col-auto text-white fw-bold">
                                            <i class="las la-star me-2 text-warning">
                                            </i>{'10'}

                                        </div>

                                    </div>

                                </div>
                                <div class="position-absolute bottom-0 end-0 w-100" >
                                    <div class="d-flex justify-content-end align-items-end">
                                        <div class="px-3 py-2 bg-dark bg-opacity-75 d-flex" >
                                            <div class="d-flex ">
                                                <div class="small headings-font-family text-white me-3 text-start">
                                                    {'Price per week  starting from'}

                                                </div>

                                            </div>
                                            <div class="d-flex justify-content-end align-items-end">
                                                <div class="h2 text-warning fw-bolder mb-0">
                                                    <span class="details-currency">{'€'}
                                                    </span>
                                                    <span class="price" data-priceeuro="2945">
                                                        {'2.945'}

                                                    </span>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                            <div class="card-body d-flex flex-column justify-content-between px-4 py-3">
                                <div class="row">
                                    <div class="col">
                                        <div class="h3 mb-2 fw-bolder object-title">Villa #1
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-betwee">
                                    <div class="col-auto">
                                        <div class="row g-0">
                                            <div class="col-auto"> <i class="las la-bed me-2 text-warning la-lg">
                                            </i>
                                            </div>
                                            <div class="col d-flex align-items-center"> <span class="text-muted small">4 bedrooms
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="row g-0">
                                            <div class="col-auto"> <i class="las la-user me-2 text-warning la-lg">
                                            </i>
                                            </div>
                                            <div class="col d-flex align-items-center"> <span class="text-muted small"> 8 guests
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="row g-0">
                                            <div class="col-auto"> <i class="las la-paw me-2 text-warning la-lg">
                                            </i>
                                            </div>
                                            <div class="col d-flex align-items-center"> <span class="text-muted small "> Pets allowed
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes })
        {

            const {
                link,
                backgroundImage,
                title,
                description,
                viewMore
            } = attributes;

            return ('');
        },
    });
}
}